<div class="container">
  <h1 class="title" mat-dialog-title>{{title}}</h1>
  <button class="cross" mat-icon-button [mat-dialog-close]="true"><mat-icon>close</mat-icon></button>
  <div mat-dialog-content class="description" [innerHtml]="description"></div>
  <div mat-dialog-actions class="actions">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
  </div>
</div>